import Login from "../Login"

function Root () {
    return <Login/>
}

export default Root